import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { hexToRgb } from 'embed/utils'
import { css } from 'emotion'
import * as React from 'react'
const styles = require('./styles.scss')

export interface BadgeItem {
  iconUrl?: string
  label: string
}

export interface BadgeProps {
  badgeItem: BadgeItem
}

export const Badge = ({ badgeItem }: BadgeProps) => (
  <ThemeConsumer>
    {({ borderRadiusSmall, colorBorder, colorPrimary, fontFamilyPrimary }) => (
      <div
        data-test-id="badge"
        className={classnames(
          styles.badge,
          css(`
        background-color: rgba(${hexToRgb(colorPrimary)?.r}, ${hexToRgb(colorPrimary)?.g}, ${
            hexToRgb(colorPrimary)?.b
          }, 0.1);
        border-radius: ${borderRadiusSmall};
        border-color: ${colorBorder};
        color: ${colorPrimary};
        font-family: ${fontFamilyPrimary};
      `),
        )}
      >
        <div className={classnames(styles.rowContainer)}>
          {badgeItem.iconUrl && (
            <div data-test-class="icon" className={classnames(styles.icon)}>
              <img src={badgeItem.iconUrl} />
            </div>
          )}
          <p>{badgeItem.label}</p>
        </div>
      </div>
    )}
  </ThemeConsumer>
)
